import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { inject, observer } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import EstimateEditor from 'components/DocEditor/EstimateEditor';
import { DocSkeleton } from 'components/DocEditor/DocSkeleton';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// An estimate (/dashboard/quotes/:id/show): components/DocEditor.
// (Technicians have their own page, pages/technician/quoteShow.js.)
@inject('quoteStore', 'viewStore') @observer
class QuoteShowPage extends Component {

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.quoteStore.loadQuote({ uuid });
  };

  // An estimate that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { quoteStore: { quote }, viewStore } = this.props;
    const missing = quote.errorStatus === 404 || quote.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to estimates', icon: 'arrow-left', onClick: () => viewStore.quotes() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="document"
            title="This estimate isn't here"
            message="It may have been deleted, or the link may be wrong. Find it in your estimates instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The estimate couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { quoteStore: { quote: { isLoading, isError, object, errorStatus } } } = this.props;
    let content;
    let title;
    // Once shown, the estimate stays on screen while it saves or reloads.
    if (object && object.id && object.attributes) {
      title = `${object.attributes.number} estimate | Field Nexus`;
      content = <EstimateEditor key={object.id} />;
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Estimate not found' : "Couldn't load estimate"} | Field Nexus`;
      content = this.renderError();
    } else {
      title = 'Loading..';
      content = <DocSkeleton noun="estimate" />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          {content}
        </PageWrapGray>
      </div>
    );
  }
}

export default QuoteShowPage;
